module.exports = __webpack_public_path__ + "assets/img/doctor-head-backright.0c24c290.png";